import React from 'react';
import css from './SectionOfferingsForm.module.css';
import { FieldTextInput } from '../../../components';
import { Field } from 'react-final-form';
const PersonalizationFormField = ({ label, placeholder, fieldName, rows }) => {
  return (
    <div className={css.fieldGroup}>
      <Field name={fieldName}>
        {({ input }) => (
          <FieldTextInput
            {...input}
            id="personalization"
            type="textarea"
            label={label}
            placeholder={placeholder}
            rows={rows}
          />
        )}
      </Field>
    </div>
  );
};

export default PersonalizationFormField;
